import {
  uploadFile,
  getFile,
  // user
  getUsers,
  createUser,
  getSingleUser,
  updateUser,
  deleteUser,
  // roles
  getRoles,
  createRole,
  updateRole,
  deleteRole,
  // groups
  getGroups,
  getUserPhones,
  addUserPhone,

  getUsersAsync,
  updateUserPassword,
} from '@/api/userManagement'

export default {
  FETCH_USER_PHONES({
    commit,
  }, params) {
    return getUserPhones(params).then(res => {
      commit('SET_USER_PHONES', res.data)
    })
  },
  ADD_USER_PHONE(_, data) {
    return addUserPhone(data)
  },
  FETCH_SINGLE_FILE(a, data) {
    return getFile(data) // спрашиваю файл по id
  },
  UPLOAD_FILE(a, data) {
    return uploadFile(data)
  },
  // user
  FETCH_USERS({ commit }, params) {
    return getUsers(params)
      .then(response => {
        commit('SET_USERS', response.data)
        return response.data
      })
      .catch(error => {
        return error
      })
  },
  CREATE_USER(a, data) {
    return createUser(data)
  },

  UPDATE_USER({
    commit,
  }, data) {
    return new Promise((resolve, reject) => {
      updateUser(data)
        .then(response => {
          commit('SET_ONE_USER', response.data)
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  DELETE_USER(_, id) {
    return deleteUser(id)
  },
  FETCH_SINGLE_USER({
    commit,
  }, data) {
    return getSingleUser(data).then(res => {
      commit('SET_USER', res.data)
      return res
    })
  },

  FETCH_ROLES({
    commit,
  }, params) {
    return new Promise((resolve, reject) => {
      getRoles(params)
        .then(response => {
          commit('SET_ROLES', response.data)
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  CREATE_ROLE(a, params) {
    return createRole(params)
  },
  UPDATE_STATUS_ROLE(a, params) {
    return updateRole(params)
  },
  UPDATE_ROLE({
    commit,
  }, data) {
    return new Promise((resolve, reject) => {
      updateRole(data)
        .then(response => {
          commit('SET_ONE_ROLE', response.data)
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  DELETE_ROLE(a, data) {
    return deleteRole(data)
  },

  // groups

  FETCH_GROUPS({
    commit,
  }, params) {
    return new Promise((resolve, reject) => {
      getGroups(params)
        .then(response => {
          commit('SET_GROUPS', response.data)
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  FETCH_USERS_ASYNC({ commit }, params) {
    return getUsersAsync(params).then(res => {
      if (!params.search) {
        commit('SET_USERS_ASYNC', res.data)
      }
      return res.data
    })
  },

  UPDATE_USER_PASSWORD(_, data) {
    return updateUserPassword(data).then(res => res.data)
  },
}
